import { Delete, Edit } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { openRequestModal } from '../../../actions/modals';
import models_V2Service from '../../../services/models_V2.service';
import quizService from '../../../services/quiz.service';
import ComponentTable from '../../ComponentTable';

export default function TableQuizzes({ className }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isEmpty } = useSelector(state => state.AsyncTable.table);

    const actions = [
        {
            title: t('modals_name.edit'),
            onClick: id =>
                dispatch(
                    openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            header: t('quiz.quizEdit'),
                            modaltype: 'EditQuiz',
                        },
                    })
                ),
            Icon: Edit,
        },
        {
            title: t('news.delete'),
            onClick: id =>
                dispatch(
                    openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            header: t('quiz.quizDelete'),
                            modaltype: 'RemoveQuiz',
                        },
                    })
                ),
            Icon: Delete,
        },
    ];
    return (
        <ComponentTable
            source={{
                getData: (page, size, sort, filter) =>
                    quizService.GetQuizBossList(false, {
                        page: page || 0,
                        size: size || 10,
                        orderBy: (sort && sort.orderBy) || null,
                        order: (sort && sort.order) || 'asc',
                        filter,
                    }),

                getModel: () => models_V2Service.QuizzesBossList(),
            }}
            actions={actions}
            selectable={true}
            enableFilter={true}
            title={t('modals.list')}
            enableSettings
            toolbarvisible={true}
            typeTable="QuizBossTable"
        />
    );
}
